import {
  ALERT_COMPARISON_TYPE_OPTIONS,
  ALERT_SIGNAL_TYPE_OPTIONS,
  ALERT_TYPE_OPTIONS,
  ALERT_VALUE_TYPE_OPTIONS,
  FORM_ERROR_MESSAGES,
} from "@shared/constants";
import { Alert } from "@shared/models";
import * as Yup from "yup";
import { AlertFormShape, CreateAlertDto } from "@containers/Alert/interfaces";

export const commonValidationSchema = {
  value_type: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
  signal_type: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
  alert_type: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
  comparison_type: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
  minimal_count: Yup.number()
    .min(1, "Value must be a number and between 1 and 30 days")
    .max(30, "Value must be a number and between 1 and 30 days")
    .required(FORM_ERROR_MESSAGES.REQUIRED),
  value: Yup.number()
    .required(FORM_ERROR_MESSAGES.REQUIRED)
    .when("value_type", {
      is: (value_type: string) => value_type === "percentage",
      then: Yup.number()
        .typeError(FORM_ERROR_MESSAGES.NUMBER)
        .min(1, FORM_ERROR_MESSAGES.PERCENT_VALUE)
        .max(100, FORM_ERROR_MESSAGES.PERCENT_VALUE),
    })
    .when("value_type", {
      is: (value_type: string) => value_type === "absolute",
      then: Yup.number()
        .typeError(FORM_ERROR_MESSAGES.NUMBER)
        .min(1, FORM_ERROR_MESSAGES.ABSOLUTE_VALUE)
        .max(50, FORM_ERROR_MESSAGES.ABSOLUTE_VALUE),
    }),
  id: Yup.number().optional(),
  user_id: Yup.number().optional().nullable(),
  is_active: Yup.boolean().optional(),
};

export const createValidationSchemaSchema: Yup.SchemaOf<AlertFormShape> = Yup.object().shape({
  alert_settings: Yup.array().of(Yup.object().shape({ ...commonValidationSchema })),
});

export const getInitValues = (alertList: Alert[]): AlertFormShape => ({
  alert_settings: alertList.map((a) => ({
    ...(a.id ? { id: Number(a.id) } : {}),
    value_type: a.value_type ? a.value_type : ALERT_VALUE_TYPE_OPTIONS[0].value,
    signal_type: a.signal_type ? a.signal_type : ALERT_SIGNAL_TYPE_OPTIONS[0].value,
    alert_type: a.alert_type ? a.alert_type : ALERT_TYPE_OPTIONS[0].value,
    comparison_type: a.comparison_type ? a.comparison_type : ALERT_COMPARISON_TYPE_OPTIONS[0].value,
    minimal_count: a.minimal_count ? a.minimal_count : 30,
    value: a.value ? Number(a.value) : 5,
    user_id: a.user_id ? a.user_id : null,
    is_active: a.is_active,
  })),
});

export const prepareSubmitValue = (values: AlertFormShape, userId: number | null): CreateAlertDto["alert_settings"] => {
  const preparedValue = values.alert_settings.map((as) => ({
    alert_type: as.alert_type,
    signal_type: as.signal_type,
    comparison_type: as.comparison_type,
    value_type: as.value_type,
    minimal_count: Number(as.minimal_count),
    user_id: userId,
    value: Number(as.value),

    is_active: as.is_active,
    ...(as.id ? { id: Number(as.id) } : {}),
  }));

  return preparedValue;
};
